import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export type SlugStatus = "idle" | "checking" | "available" | "taken" | "invalid_format";

const SLUG_RE = /^[a-z0-9-]{3,32}$/;

export function useSlugAvailability(slug: string, debounceMs = 300): SlugStatus {
  const [status, setStatus] = useState<SlugStatus>("idle");

  useEffect(() => {
    if (!slug) { setStatus("idle"); return; }
    if (!SLUG_RE.test(slug)) { setStatus("invalid_format"); return; }

    setStatus("checking");
    let cancelled = false;
    const timer = setTimeout(async () => {
      const { data } = await supabase
        .from("tenants")
        .select("id")
        .eq("slug", slug)
        .maybeSingle();
      if (cancelled) return;
      setStatus(data ? "taken" : "available");
    }, debounceMs);

    return () => { cancelled = true; clearTimeout(timer); };
  }, [slug, debounceMs]);

  return status;
}
